import MarketPlaceTemp from "../templates/NFTS/MarketPlaceTemp";

const MarketPlace = () => <MarketPlaceTemp />;

export default MarketPlace;